export const Logo = ({ className = "h-11 w-11" }) => (
  <span className={`inline-flex shrink-0 items-center justify-center overflow-hidden rounded-xl bg-white ${className}`}>
    <img src="/logo-mark.png" alt="Go Box logo" className="h-full w-full object-contain" data-testid="logo-mark" />
  </span>
);
